module.exports = __webpack_public_path__ + "static/media/boatImage.d61546cd.jpg";